<template>
  <v-app>
    <v-navigation-drawer app clipped v-if="isSignedin">
      <v-list-item dense :to="{ name: 'dashboard' }">
        <v-list-item-content>
          <v-list-item-title class="text-body-2 font-weight-medium">
            {{ $t('menu.home') }}
          </v-list-item-title>
          <v-list-item-subtitle class="text-caption">
            {{ $t('menu.homeSubtitle') }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item dense :to="{ name: 'api' }" v-if="showDeveloperAPI">
        <v-list-item-avatar tile size="24" class="mr-3">
          <v-icon color="primary">mdi-api</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-body-2 font-weight-medium">{{
            $t('menu.legacy')
          }}</v-list-item-title>
          <v-list-item-subtitle class="text-caption">{{
            $t('menu.legacySubtitle')
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item dense :to="{ name: 'apiData' }">
        <v-list-item-avatar tile size="24" class="mr-3">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="red"
                class="blink-animation"
                v-bind="attrs"
                v-on="on"
                >mdi-alert-circle-outline</v-icon
              >
            </template>
            <span>{{ $t('menu.deprecatedTooltip') }}</span>
          </v-tooltip>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-body-2 font-weight-medium">
            {{ $t('menu.data') }}
          </v-list-item-title>
          <v-list-item-subtitle class="text-caption">{{
            $t('menu.integrationSubtitle')
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item dense :to="{ name: 'apiDataImport' }">
        <v-list-item-avatar tile size="24" class="mr-3">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="red"
                class="blink-animation"
                v-bind="attrs"
                v-on="on"
                >mdi-alert-circle-outline</v-icon
              >
            </template>
            <span>{{ $t('menu.deprecatedTooltip') }}</span>
          </v-tooltip>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-body-2 font-weight-medium">
            {{ $t('menu.import') }}
          </v-list-item-title>
          <v-list-item-subtitle class="text-caption">{{
            $t('menu.integrationSubtitle')
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item dense :to="{ name: 'engagement' }" v-if="showDeveloperAPI">
        <v-list-item-avatar tile size="24" class="mr-3">
          <v-img
            :src="$t('menu.icons.engagement')"
            height="24"
            width="24"
            contain
          ></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-body-2 font-weight-medium">{{
            $t('menu.engagement')
          }}</v-list-item-title>
          <v-list-item-subtitle class="text-caption">{{
            $t('menu.engagementSubtitle')
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item dense :to="{ name: 'engagement-service' }">
        <v-list-item-avatar tile size="24" class="mr-3">
          <v-img
            :src="$t('menu.icons.engagement')"
            height="24"
            width="24"
            contain
          ></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-body-2 font-weight-medium">{{
            $t('menu.engagementService')
          }}</v-list-item-title>
          <v-list-item-subtitle class="text-caption">{{
            $t('menu.engagementSubtitle')
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item dense :to="{ name: 'performance' }" v-if="showDeveloperAPI">
        <v-list-item-avatar tile size="24" class="mr-3">
          <v-img
            :src="$t('menu.icons.performance')"
            height="24"
            width="24"
            contain
          ></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-body-2 font-weight-medium">{{
            $t('menu.performance')
          }}</v-list-item-title>
          <v-list-item-subtitle class="text-caption">{{
            $t('menu.performanceSubtitle')
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item dense :to="{ name: 'performance-service' }">
        <v-list-item-avatar tile size="24" class="mr-3">
          <v-img
            :src="$t('menu.icons.performance')"
            height="24"
            width="24"
            contain
          ></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-body-2 font-weight-medium">
            {{ $t('menu.performanceService') }}
          </v-list-item-title>
          <v-list-item-subtitle class="text-caption">{{
            $t('menu.performanceSubtitle')
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item dense :to="{ name: 'growth' }" v-if="showDeveloperAPI">
        <v-list-item-avatar tile size="24" class="mr-3">
          <v-img
            :src="$t('menu.icons.growth')"
            height="24"
            width="24"
            contain
          ></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-body-2 font-weight-medium">
            {{ $t('menu.growth') }}
          </v-list-item-title>
          <v-list-item-subtitle class="text-caption">{{
            $t('menu.growthSubtitle')
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item dense :to="{ name: 'growth-service' }">
        <v-list-item-avatar tile size="24" class="mr-3">
          <v-img
            :src="$t('menu.icons.growth')"
            height="24"
            width="24"
            contain
          ></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-body-2 font-weight-medium">
            {{ $t('menu.growthService') }}
          </v-list-item-title>
          <v-list-item-subtitle class="text-caption">{{
            $t('menu.growthSubtitle')
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        dense
        :to="{ name: 'customSurveys' }"
        v-if="showDeveloperAPI"
      >
        <v-list-item-avatar tile size="24" class="mr-3">
          <v-img
            :src="$t('menu.icons.custom_survey')"
            height="24"
            width="24"
            contain
          ></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-body-2 font-weight-medium">{{
            $t('menu.customSurveys')
          }}</v-list-item-title>
          <v-list-item-subtitle class="text-caption">{{
            $t('menu.customSurveysSubtitle')
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item dense :to="{ name: 'custom-surveys-service' }">
        <v-list-item-avatar tile size="24" class="mr-3">
          <v-img
            :src="$t('menu.icons.custom_survey')"
            height="24"
            width="24"
            contain
          ></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-body-2 font-weight-medium">{{
            $t('menu.customSurveysService')
          }}</v-list-item-title>
          <v-list-item-subtitle class="text-caption">{{
            $t('menu.customSurveysSubtitle')
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item dense :to="{ name: 'management' }" v-if="showDeveloperAPI">
        <v-list-item-avatar tile size="24" class="mr-3">
          <v-img
            :src="$t('menu.icons.management')"
            height="24"
            width="24"
            contain
          ></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-body-2 font-weight-medium">{{
            $t('menu.management')
          }}</v-list-item-title>
          <v-list-item-subtitle class="text-caption">{{
            $t('menu.managementSubtitle')
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item dense :to="{ name: 'management-service' }">
        <v-list-item-avatar tile size="24" class="mr-3">
          <v-img
            :src="$t('menu.icons.management')"
            height="24"
            width="24"
            contain
          ></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-body-2 font-weight-medium">{{
            $t('menu.managementService')
          }}</v-list-item-title>
          <v-list-item-subtitle class="text-caption">{{
            $t('menu.managementSubtitle')
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item dense :to="{ name: 'scim' }" v-if="showDeveloperAPI">
        <v-list-item-avatar tile size="24" class="mr-3">
          <v-icon color="primary">mdi-account-cog-outline</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-body-2 font-weight-medium">{{
            $t('menu.scim')
          }}</v-list-item-title>
          <v-list-item-subtitle class="text-caption">{{
            $t('menu.scimSubtitle')
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item dense :to="{ name: 'scim-idp' }">
        <v-list-item-avatar tile size="24" class="mr-3">
          <v-icon color="primary">mdi-account-sync-outline</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-body-2 font-weight-medium">{{
            $t('menu.scimIdp')
          }}</v-list-item-title>
          <v-list-item-subtitle class="text-caption">{{
            $t('menu.scimIdpSubtitle')
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item dense :to="{ name: 'mcp-service' }" v-if="showDeveloperAPI">
        <v-list-item-avatar tile size="24" class="mr-3">
          <v-icon color="primary">mdi-robot-outline</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-body-2 font-weight-medium">{{
            $t('menu.mcpService')
          }}</v-list-item-title>
          <v-list-item-subtitle class="text-caption">{{
            $t('menu.mcpServiceSubtitle')
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item dense :to="{ name: 'lms' }" v-if="showDeveloperAPI">
        <v-list-item-avatar tile size="24" class="mr-3">
          <v-icon color="primary">mdi-school-outline</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-body-2 font-weight-medium">{{
            $t('menu.lms')
          }}</v-list-item-title>
          <v-list-item-subtitle class="text-caption">{{
            $t('menu.lmsSubtitle')
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        dense
        :to="{ name: 'google-chat-events' }"
        v-if="showDeveloperAPI"
      >
        <v-list-item-avatar tile size="24" class="mr-3">
          <v-icon color="primary">mdi-chat-outline</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-body-2 font-weight-medium">{{
            $t('menu.googleChatEvents')
          }}</v-list-item-title>
          <v-list-item-subtitle class="text-caption">{{
            $t('menu.googleChatEventsSubtitle')
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item dense :to="{ name: 'rewards' }" v-if="showDeveloperAPI">
        <v-list-item-avatar tile size="24" class="mr-3">
          <v-icon color="primary">mdi-gift-outline</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-body-2 font-weight-medium">{{
            $t('menu.rewards')
          }}</v-list-item-title>
          <v-list-item-subtitle class="text-caption">{{
            $t('menu.rewardsSubtitle')
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item dense :to="{ name: 'trustline' }" v-if="showDeveloperAPI">
        <v-list-item-avatar tile size="24" class="mr-3">
          <v-icon color="primary">mdi-handshake-outline</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-body-2 font-weight-medium">{{
            $t('menu.trustline')
          }}</v-list-item-title>
          <v-list-item-subtitle class="text-caption">{{
            $t('menu.trustlineSubtitle')
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item dense :to="{ name: 'notification' }" v-if="showDeveloperAPI">
        <v-list-item-avatar tile size="24" class="mr-3">
          <v-icon color="primary">mdi-bell-outline</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-body-2 font-weight-medium">{{
            $t('menu.notification')
          }}</v-list-item-title>
          <v-list-item-subtitle class="text-caption">{{
            $t('menu.notificationSubtitle')
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-navigation-drawer>

    <v-app-bar app color="primary" dark fixed clipped-left v-if="isSignedin">
      <div class="d-flex align-center">
        <h2>TeamCulture Developer Portal</h2>
      </div>

      <v-spacer></v-spacer>

      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn text v-bind="attrs" v-on="on" class="mr-2">
            <span class="mr-1">{{ currentFlag }}</span> {{ currentLangName }}
            <v-icon right>mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="lang in langs"
            :key="lang.code"
            @click="changeLocale(lang.code)"
          >
            <v-list-item-title
              >{{ lang.flag }} {{ lang.name }}</v-list-item-title
            >
          </v-list-item>
        </v-list>
      </v-menu>

      <v-btn text @click="logout">
        <span class="mr-2">{{ $t('menu.logout') }}</span>
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main class="page">
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { projectAuth } from '@/firebase/config'
import { showDeveloperAPI } from '@/helpers/sentinel'

export default {
  name: 'App',
  components: {},

  data: () => ({
    isSignedin: true,
    showDeveloperAPI: showDeveloperAPI,
    langs: [
      { code: 'pt-br', name: 'Português', flag: '🇧🇷' },
      { code: 'en-us', name: 'English', flag: '🇺🇸' },
      { code: 'es-ar', name: 'Español', flag: '🇦🇷' },
    ],
  }),

  created() {
    this.isSignedin = false
    const $store = this.$store
    // console.log('[App.user]', user)
    projectAuth.onAuthStateChanged(async (user) => {
      if (user) {
        this.isSignedin = true
        // User is signed in.
        $store.dispatch('currentUser/loadCurrentUser', user)
      } else {
        this.isSignedin = false
        // User is signed out.
        $store.dispatch('currentUser/loadCurrentUser', {})
      }
    })
  },

  methods: {
    async logout() {
      projectAuth.signOut().then(() => {
        this.$router.push('/logout')
      })
    },
    changeLocale(locale) {
      this.$i18n.locale = locale
    },
  },
  computed: {
    currentFlag() {
      const current = this.langs.find((l) => l.code === this.$i18n.locale)
      return current ? current.flag : '🌐'
    },
    currentLangName() {
      const current = this.langs.find((l) => l.code === this.$i18n.locale)
      return current ? current.name : ''
    },
  },
  mounted() {},
}
</script>

<style lang="scss">
@import '@/global.scss';

.blink-animation {
  animation: blink 1.5s infinite;
}

@keyframes blink {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.3;
  }

  100% {
    opacity: 1;
  }
}

.bullet-deprecated {
  color: #dd0041;
  font-size: 24px;
  line-height: 1;
}

.page {
  background-color: $bg-1 !important;
  padding: 10px 35px !important;

  &.modal {
    height: calc(100vh - 24px);
    overflow: hidden;
  }
}
</style>
